import { bl_inv_pdg_outlet_type_filter_link_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class InventoryPdgOutletTypeFilterLinkContainerModel extends BaseContainerModel {
  bl_inv_pdg_outlet_type_filter_link: bl_inv_pdg_outlet_type_filter_link_RowClass = new bl_inv_pdg_outlet_type_filter_link_RowClass();
}
